
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SePersonaAvatarModule, SE_PERSONA_AVATAR_MODULE_BUNDLE } from '../persona-avatar/persona-avatar.module'
import { SeOrgAvatarModule, SE_ORG_AVATAR_MODULE_BUNDLE } from '../org-avatar/org-avatar.module'
import { SeTeamAvatarModule, SE_TEAM_AVATAR_MODULE_BUNDLE } from '../team-avatar/team-avatar.module'
import { SeIconModule } from '../icon/icon.module'

import { SeCommonAvatarComponent } from './common-avatar.component'

@NgModule({
  imports: [
	CommonModule, 
    SeIconModule,
    SePersonaAvatarModule,
    SeOrgAvatarModule,
    SeTeamAvatarModule
  ],
  declarations: [
    SeCommonAvatarComponent,
  ],
  exports: [
    SeCommonAvatarComponent
  ]
})
export class SeCommonAvatarModule {}

const dependencies = [
  SE_PERSONA_AVATAR_MODULE_BUNDLE,
  SE_ORG_AVATAR_MODULE_BUNDLE,
  SE_TEAM_AVATAR_MODULE_BUNDLE
]

export const SE_COMMON_AVATAR_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.commonAvatar`

